import i18n from "src/i18n";

export const getSelectedLanguage = () => {
    const selectedLanguageKey = i18n.language;
    return selectedLanguageKey;
};
